export class StocksQuery {
  constructor () {
    this.ean = undefined;
    this.current = undefined;
    this.pageSize = undefined;
    this.warehouse = undefined;
    this.availability = undefined;
  }

  static get KEYS () {
    return {
      EAN: 'ean',
      WAREHOUSE: 'warehouse',
      AVAILABILITY: 'availability'
    };
  }
}
